<script setup lang="ts">
import type { InteractionEditorProps } from '../../../../model/assessments/interaction-editors.hook'

import { AppText } from '@shared/ui/typography'
import { BtnCheckbox } from '@shared/ui/buttons'

import { useInteractionOpenEnded } from '../../../../model/assessments/interaction-editors.hook'

defineOptions({
  name: 'InteractionOpenEnded',
})

const props = defineProps<InteractionEditorProps>()

const {
  refFormatItems,
  refHasNoFormat,
  toggleFormat,
} = useInteractionOpenEnded({
  screenId: () => props.screenId,
  activityId: () => props.activityId,
  interaction: () => props.interaction,
})
</script>

<template>
  <div class="interaction-open-ended">
    <AppText
      name="body2"
      color="slate-500"
    >
      The kid answers freely. Tick the ways they may answer; with more than one, the kid switches
      between them with tabs. The prompt lives in this activity's content blocks above.
    </AppText>

    <AppText name="body2-medium">
      Answer formats
    </AppText>

    <div class="interaction-open-ended__formats">
      <BtnCheckbox
        v-for="item in refFormatItems"
        :key="item.format"
        :text="item.label"
        :checked="item.checked"
        @click="toggleFormat(item.format)"
      />
    </div>

    <AppText
      v-if="refHasNoFormat"
      name="body2"
      color="slate-500"
    >
      An open ended activity needs at least one answer format.
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./InteractionOpenEnded.scss" />
